import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import { getDataFromStorage, isParentLogin } from "../../../../../../util";
import MockTestLibraryHooks from "../../../../../../Hooks/Mock/Student/MockTestLibraryHooks";
import Tooltip from "../../../../../CommonComponents/Tooltip";
// import Tooltip from "../../../../../CommonComponents/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import { SOAMockTestsSkeleton } from "./SOAMockTestsSkeleton";

const SOAMockTests = () => {
  const axios = useAxiosPrivate();
  const batchid = localStorage.getItem("batchid");
  const learnerid = getDataFromStorage("learnerid");

  const [mockTests, setMockTests] = useState([]);

  useEffect(() => {
    const fetchMockTests = async () => {
      try {
        const response = await axios.get(
          `node/learner/mock/lib?lid=${learnerid}&bid=${batchid}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const tests = response.data?.data?.tests ?? [];
        setMockTests(tests);
      } catch (error) {
        console.error("error", error);
      }
    };
    if (learnerid) fetchMockTests();
  }, [axios, batchid, learnerid]);

  if (!mockTests?.length > 0) {
    return <SOAMockTestsSkeleton />;
  }

  return (
    <div className="SOAMockTests-Container">
      <div className="SOAMockTests-Header">Mock Tests</div>
      {/* <div className="SOAMockTests-Container"> */}
        <div className="SOAMockTests-Body">
          <p className="SOAMockTests-Body-Header">Learn and Practice</p>
          <div className="SOAMockTests-Body-Contents">
            {mockTests.map((item) => (
              <SOAMockTest item={item} key={item.id} />
            ))}
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};

const formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min${minutes !== 1 ? "s" : ""}`;
  }

  const hours = minutes / 60;
  if (hours < 24) {
    return Number.isInteger(hours)
      ? `${hours} hour${hours !== 1 ? "s" : ""}`
      : `${Math.round(hours * 10) / 10} hours`;
  }

  const days = hours / 24;
  return `${days.toFixed(1)} day${days !== 1 ? "s" : ""}`;
};

const SOAMockTest = ({ item }) => {
  const MockTestLibraryHks = MockTestLibraryHooks();
  if (!item) return;

  const duration = formatDuration(item.testduration / 60);

  return (
    <section
      className="SOAMockTest-Container"
      key={item.id}
      style={{ cursor: !isParentLogin ? "pointer" : "default" }}
      onClick={() => {
        !isParentLogin && MockTestLibraryHks.handleTest(item);
      }}
    >
      <div className="SOAMockTest-Section">
        <div className="SOAMockTest-Left-Section">
          <Tooltip title={item.name} placement="bottom">
            <p className="SOAMockTest-Left-Section-Header">{item.name}</p>
          </Tooltip>
          <span className="SOAMockTest-Left-Section-QnCount">
            ({item.questionscount ?? 0} question
            {item.questionscount !== 1 ? "s" : ""})
          </span>
        </div>
        <p className="SOAMockTest-Right-Section">{duration}</p>
      </div>
    </section>
  );
};

export default SOAMockTests;
